import { MappedRoute } from 'src/dtos/custom'

export const calculatePercentages = (inputRoute: string | undefined, routesMapping: MappedRoute[], isRenew: boolean = false, isJudge: boolean = false) => {
  let percentages = {
    subSectionPercentage: 0,
    completionPercentage: 0
  }
  
  if(!inputRoute) return percentages
  const currentRoute = inputRoute?.toLowerCase()

  const mappedRoutesArray = routesMapping.map(route => route.subroute.map(sub => 
    `${isRenew === true ? '/customer/renew' : ''}${isJudge === true ? '/judge' : ''}/${route.route}/${sub}`
    )).flat()

  const currentRouteIndex = mappedRoutesArray.findIndex(mapped => mapped === currentRoute)

  const splittedRoute = currentRoute.split('/')
  const route = splittedRoute[splittedRoute.length - 2]

  if(currentRouteIndex < 0) return percentages

  const completionPercentage = Math.round(((currentRouteIndex + 1)/ mappedRoutesArray.length) * 100)

  const mappedSubroutesArray = mappedRoutesArray.filter(mapped => {
    const splittedMapped = mapped.split('/')
    const mappedRoute = splittedMapped[splittedMapped.length - 2]
    return mappedRoute === route
  })

  const subrouteIndex = mappedSubroutesArray.findIndex(sub => sub === currentRoute)

  if(subrouteIndex < 0) return { ...percentages, completionPercentage }

  const addition = currentRouteIndex === mappedRoutesArray.length - 1 ? 0 : 1

  const subSectionPercentage = Math.round(((subrouteIndex + 1)/ (mappedSubroutesArray.length + addition)) * 100)

  return {
    completionPercentage,
    subSectionPercentage
  }
}